import { Injectable } from '@angular/core';

import { ConfigurationService } from '../../services/configuration.service';

@Injectable()
export class BrandService  extends ConfigurationService {

    public modelPath = 'pharmacy/brands';

    getDTColumns () {
        const self = this;
        return [{
            name: 'brand_id',
            title: 'Brand Id',
            visible: false,
            orderable: false,
            searchable: false,
            data: 'brand_id'
        }, {
            name: 'brand_name',
            title: 'Brand Name',
            data: 'brand_name'
        }, {
            name: 'brand_code',
            title: 'Brand Code',
            data: 'brand_code'
        }, {
            title: 'Status',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-brand')) {
                    return `<div class="custom-control custom-checkbox">
						<input class="custom-control-input" data-modelPk="checkbox_${full.brand_id}" id="checkbox_${full.brand_id}" type="checkbox" />
						<label class="custom-control-label" for="checkbox_${full.brand_id}"></label>
					</div>`;
                }
                return `<label class="label label-${full.status === 1 ? 'success' : 'danger'}">
					${full.status === 1 ? 'Active' : 'Inactive'}
				</label>`;
            }
        }, {
            title: 'Action',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-brand')) {
                    return `<a href="javascript:void(0)" data-modelPk="${full.brand_id}" class="btn btn-secondary">
						<i data-modelPk="${full.brand_id}" class="icon-pencil"></i>
					</a>`;
                }
                return '';
            }
        }];
    }
}
